import Loader_AB_2771 from "@Common/Loader_AB_2771";
import { useElementCssHeight, useHandleResize } from "@hook";
import ButtonUi from "@UI/ButtonUi";
import { getStoredLocation, getWhatId, sendMetric } from "@utils";
import { inject, observer } from "mobx-react";
import { useState, useMemo, useRef } from "react";

import "./style.scss";

const { VITE_WHAT_ID } = import.meta.env;

const defaultRegion = {
    name_with_type: "Регион не выбран",
};

const AB_2771 = inject("mainStore")(
    observer(({ mainStore }) => {
        const userLocation = mainStore.getMainStore("userLocation");
        const abTestMetika = mainStore.getMainStore("abTestMetika");
        const citiesData = mainStore.getMainStore("citiesData");

        const isMobile = useHandleResize();
        const storedLocaleSource = localStorage.getItem("locale_ris_promo_source");
        const userLocationCity = useMemo(() => {
            if (!Array.isArray(citiesData)) return null;

            const location = userLocation?.data || userLocation?._gtip?.data || userLocation;
            const locationRegion = location?.region;
            const locationCity = location?.city;
            const cityId = location?.cityId || locationCity?._id || locationCity?.id || location?._id;
            const cityName = locationCity?.city || locationCity?.name || locationCity?.name_with_type || (typeof locationCity === "string" ? locationCity : location?.city);
            const regionId = location?.regionId || locationRegion?._id || locationRegion?.id;

            return citiesData.find((item) => cityId && item._id === cityId) || citiesData.find((item) => cityName && item.city === cityName && (!regionId || item.regionId === regionId)) || null;
        }, [citiesData, userLocation]);

        const localStorageUser = getStoredLocation() || userLocationCity || defaultRegion;

        const [userRegionCity, setUserRegionCity] = useState(false);
        const [isCityConfirmed, setIsCityConfirmed] = useState(false);
        const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;
        const hasSelectedCity = Boolean(localStorageUser?.city);
        const hasDetectedLocation = Boolean((userLocation?.data?.region && userLocation?.data?.city) || (userLocation?._gtip?.data?.region && userLocation?._gtip?.data?.city));
        const requiresCityConfirmation = Boolean(storedLocaleSource === "automatic" || (userRegionCity && typeof userRegionCity === "object") || (!storedLocaleSource && hasDetectedLocation));
        const shouldConfirmCity = hasSelectedCity && requiresCityConfirmation && !isCityConfirmed;
        const isCitySelectionVisible = shouldConfirmCity || (!hasSelectedCity && [false, "error", "updateLocationError", "loader"].includes(userRegionCity));
        const isMobileCitySelectionVisible = isMobile && isCitySelectionVisible;
        const geolocationRef = useRef(null);

        useElementCssHeight(geolocationRef, "--ab-2771-city-selection-height", isMobileCitySelectionVisible);

        const city = localStorageUser;

        const handleGeopositionUser = () => {
            setIsCityConfirmed(false);
            setUserRegionCity("loader");

            if ("geolocation" in navigator) {
                navigator.geolocation.getCurrentPosition(
                    // Успех
                    async (position) => {
                        const geo = { lat: false, lon: false };
                        geo.lat = position.coords.latitude;
                        geo.lon = position.coords.longitude;

                        if (position) {
                            const resp = await mainStore.getByUrl("/app_rispromo_user/update_location", geo, false, "", false);
                            if (resp && resp.data) {
                                const userLoc = { regionId: resp.data.regionId, cityId: resp.data.cityId };
                                const detectedCity = Array.isArray(citiesData) ? citiesData.find((item) => item._id === userLoc.cityId) : null;

                                if (detectedCity) {
                                    localStorage.setItem("locale_ris_promo", JSON.stringify(detectedCity));
                                    localStorage.setItem("locale_ris_promo_source", "automatic");
                                    await mainStore.getByUrl("app_rispromo_user/user_locations", detectedCity, true, "userLocation", false, false);
                                    await mainStore.getByUrl("/app_rispromo/offers_list", "", false, "offersList", false);
                                    setUserRegionCity(detectedCity);
                                } else {
                                    setUserRegionCity("updateLocationError");
                                }
                            } else {
                                setUserRegionCity("updateLocationError");
                                localStorage.removeItem("locale_ris_promo");
                                localStorage.removeItem("locale_ris_promo_source");
                            }
                        }
                    },
                    // Ошибка
                    (error) => {
                        setUserRegionCity("error");

                        switch (error.code) {
                            case error.PERMISSION_DENIED:
                                // mainStore.setMainStore("toast", { severity: "error", life: 4000, summary: "", detail: "Запрет доступа к геолокации" });
                                console.error("❌ Пользователь запретил доступ к геолокации.");
                                break;
                            case error.POSITION_UNAVAILABLE:
                                // mainStore.setMainStore("toast", { severity: "error", life: 4000, summary: "", detail: "Информация о местоположении недоступна." });
                                console.error("❌ Информация о местоположении недоступна.");
                                break;
                            case error.TIMEOUT:
                                // mainStore.setMainStore("toast", { severity: "error", life: 4000, summary: "", detail: " Превышено время ожидания." });
                                console.error("❌ Превышено время ожидания.");
                                break;
                            default:
                                console.error("❌ Неизвестная ошибка геолокации.");
                        }
                    },
                    // Опции
                    {
                        enableHighAccuracy: true, // запрашивать максимальную точность (GPS/Wi-Fi)
                        timeout: 10000, // ждать не более 10 секунд
                        maximumAge: 0, // не использовать кэшированную позицию
                    },
                );
            } else {
                setUserRegionCity("updateLocationError");
            }
        };

        const cityHandler = () => {
            setUserRegionCity(false);
            setIsCityConfirmed(false);
            mainStore.setMainStore("modal", { type: "geolocationUser" });

            sendMetric(`click_change_location`, {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: null,
                params3: null,
                params4: null,
                params6: null,
                params7: null,
                params8: what_id,
            });
        };

        return (
            <div ref={geolocationRef} className={`ab-2771 geolocation${!isMobile ? " geolocation_desctop" : ""}${isMobileCitySelectionVisible ? " geolocation_city-selection" : ""}`} id="geolocation">
                {shouldConfirmCity ? (
                    <div className="geolocation__vpn-block">
                        <div className="geolocation-city" id="geolocation-city">
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M11.0002 19.4788C10.8654 19.4801 10.7337 19.4384 10.6243 19.3596C10.3493 19.1854 3.896 14.8496 3.896 9.57878C3.896 7.69463 4.64447 5.88766 5.97676 4.55537C7.30905 3.22308 9.11602 2.47461 11.0002 2.47461C12.8843 2.47461 14.6913 3.22308 16.0236 4.55537C17.3559 5.88766 18.1043 7.69463 18.1043 9.57878C18.1043 14.8496 11.6877 19.1854 11.376 19.3596C11.2666 19.4384 11.1349 19.4801 11.0002 19.4788ZM11.0002 3.89544C9.48713 3.89057 8.03401 4.48632 6.95984 5.55189C5.88568 6.61747 5.27827 8.06576 5.271 9.57878C5.271 13.4379 9.66183 16.9671 11.0002 17.9479C12.3385 16.9671 16.7293 13.4379 16.7293 9.57878C16.7221 8.06576 16.1146 6.61747 15.0405 5.55189C13.9663 4.48632 12.5132 3.89057 11.0002 3.89544Z"
                                    fill={"#111111"}
                                />
                                <path
                                    d="M11.0003 11.6872C10.5018 11.6872 10.0144 11.5393 9.59983 11.2623C9.18528 10.9853 8.86218 10.5916 8.67138 10.131C8.48058 9.6704 8.43066 9.16355 8.52793 8.67455C8.6252 8.18556 8.86528 7.73639 9.21783 7.38384C9.57037 7.0313 10.0195 6.79121 10.5085 6.69395C10.9975 6.59668 11.5044 6.6466 11.965 6.8374C12.4256 7.02819 12.8193 7.35129 13.0963 7.76584C13.3733 8.18039 13.5212 8.66777 13.5212 9.16634C13.5212 9.83491 13.2556 10.4761 12.7828 10.9488C12.3101 11.4216 11.6689 11.6872 11.0003 11.6872ZM11.0003 8.02051C10.7737 8.02051 10.5522 8.08771 10.3637 8.21362C10.1753 8.33952 10.0284 8.51848 9.94172 8.72785C9.85499 8.93722 9.8323 9.16761 9.87651 9.38988C9.92072 9.61215 10.0299 9.81632 10.1901 9.97657C10.3503 10.1368 10.5545 10.2459 10.7768 10.2902C10.9991 10.3344 11.2294 10.3117 11.4388 10.225C11.6482 10.1382 11.8271 9.99136 11.9531 9.80293C12.079 9.6145 12.1462 9.39297 12.1462 9.16634C12.1462 8.86245 12.0254 8.571 11.8106 8.35612C11.5957 8.14123 11.3042 8.02051 11.0003 8.02051Z"
                                    fill={"#111111"}
                                />
                            </svg>
                            <span className="geolocation-city__name">
                                {`Ваш город `}
                                <span>{city.city}?</span>
                            </span>
                        </div>
                        <div className="geolocation-button__group">
                            <ButtonUi
                                label="Да"
                                className="button__yes"
                                onClick={() => {
                                    setIsCityConfirmed(true);
                                    localStorage.setItem("locale_ris_promo_source", "confirmed");
                                }}
                            />
                            <ButtonUi label="Изменить регион" className="button__select" onClick={cityHandler} />
                        </div>
                    </div>
                ) : null}

                {userRegionCity === "updateLocationError" ? (
                    <div className="geolocation__vpn-block">
                        <div className="geolocation-city" id="geolocation-city">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="info">
                                <path
                                    d="M8.00016 14.6673C11.6668 14.6673 14.6668 11.6673 14.6668 8.00065C14.6668 4.33398 11.6668 1.33398 8.00016 1.33398C4.3335 1.33398 1.3335 4.33398 1.3335 8.00065C1.3335 11.6673 4.3335 14.6673 8.00016 14.6673Z"
                                    stroke="#E62121"
                                    strokeWidth="1.25"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path d="M8 5.33398V8.66732" stroke="#E62121" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M7.99609 10.666H8.00208" stroke="#E62121" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <span className="geolocation-city__name">Не получилось определить ваше местоположение. Попробуйте ещё раз позже или укажите вручную</span>
                        </div>
                        <div className="geolocation-button__group">
                            <ButtonUi
                                label="Повторить попытку"
                                className="button__yes"
                                onClick={handleGeopositionUser}
                                icon={userRegionCity === "loader" ? <Loader_AB_2771 width={15} height={15} /> : null}
                                iconPos="left"
                                disabled={userRegionCity === "loader"}
                            />
                            <ButtonUi label="Указать вручную" className="button__select" onClick={cityHandler} />
                        </div>
                    </div>
                ) : null}

                {localStorageUser.name_with_type === "Регион не выбран" && [false, "loader"].includes(userRegionCity) ? (
                    <div className="geolocation__vpn-block">
                        <div className="geolocation-city" id="geolocation-city">
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M11.0002 19.4788C10.8654 19.4801 10.7337 19.4384 10.6243 19.3596C10.3493 19.1854 3.896 14.8496 3.896 9.57878C3.896 7.69463 4.64447 5.88766 5.97676 4.55537C7.30905 3.22308 9.11602 2.47461 11.0002 2.47461C12.8843 2.47461 14.6913 3.22308 16.0236 4.55537C17.3559 5.88766 18.1043 7.69463 18.1043 9.57878C18.1043 14.8496 11.6877 19.1854 11.376 19.3596C11.2666 19.4384 11.1349 19.4801 11.0002 19.4788ZM11.0002 3.89544C9.48713 3.89057 8.03401 4.48632 6.95984 5.55189C5.88568 6.61747 5.27827 8.06576 5.271 9.57878C5.271 13.4379 9.66183 16.9671 11.0002 17.9479C12.3385 16.9671 16.7293 13.4379 16.7293 9.57878C16.7221 8.06576 16.1146 6.61747 15.0405 5.55189C13.9663 4.48632 12.5132 3.89057 11.0002 3.89544Z"
                                    fill={"#111111"}
                                />
                                <path
                                    d="M11.0003 11.6872C10.5018 11.6872 10.0144 11.5393 9.59983 11.2623C9.18528 10.9853 8.86218 10.5916 8.67138 10.131C8.48058 9.6704 8.43066 9.16355 8.52793 8.67455C8.6252 8.18556 8.86528 7.73639 9.21783 7.38384C9.57037 7.0313 10.0195 6.79121 10.5085 6.69395C10.9975 6.59668 11.5044 6.6466 11.965 6.8374C12.4256 7.02819 12.8193 7.35129 13.0963 7.76584C13.3733 8.18039 13.5212 8.66777 13.5212 9.16634C13.5212 9.83491 13.2556 10.4761 12.7828 10.9488C12.3101 11.4216 11.6689 11.6872 11.0003 11.6872ZM11.0003 8.02051C10.7737 8.02051 10.5522 8.08771 10.3637 8.21362C10.1753 8.33952 10.0284 8.51848 9.94172 8.72785C9.85499 8.93722 9.8323 9.16761 9.87651 9.38988C9.92072 9.61215 10.0299 9.81632 10.1901 9.97657C10.3503 10.1368 10.5545 10.2459 10.7768 10.2902C10.9991 10.3344 11.2294 10.3117 11.4388 10.225C11.6482 10.1382 11.8271 9.99136 11.9531 9.80293C12.079 9.6145 12.1462 9.39297 12.1462 9.16634C12.1462 8.86245 12.0254 8.571 11.8106 8.35612C11.5957 8.14123 11.3042 8.02051 11.0003 8.02051Z"
                                    fill={"#111111"}
                                />
                            </svg>
                            <span className="geolocation-city__name">
                                <span>Выберите ваш город, </span>
                                чтобы мы могли показать самые актуальные и выгодные предложения
                            </span>
                        </div>
                        <div className="geolocation-button__group">
                            <ButtonUi label="Вручную" className="button__yes" onClick={cityHandler} />
                            <ButtonUi
                                label="Автоматически"
                                className="button__select"
                                onClick={handleGeopositionUser}
                                icon={userRegionCity === "loader" ? <Loader_AB_2771 width={15} height={15} /> : null}
                                iconPos="left"
                                disabled={userRegionCity === "loader"}
                            />
                        </div>
                    </div>
                ) : null}

                {hasSelectedCity && !shouldConfirmCity ? (
                    <div className="geolocation select" onClick={() => mainStore.setMainStore("modal", { type: "geolocationUser" })}>
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M11.0002 19.4788C10.8654 19.4801 10.7337 19.4384 10.6243 19.3596C10.3493 19.1854 3.896 14.8496 3.896 9.57878C3.896 7.69463 4.64447 5.88766 5.97676 4.55537C7.30905 3.22308 9.11602 2.47461 11.0002 2.47461C12.8843 2.47461 14.6913 3.22308 16.0236 4.55537C17.3559 5.88766 18.1043 7.69463 18.1043 9.57878C18.1043 14.8496 11.6877 19.1854 11.376 19.3596C11.2666 19.4384 11.1349 19.4801 11.0002 19.4788ZM11.0002 3.89544C9.48713 3.89057 8.03401 4.48632 6.95984 5.55189C5.88568 6.61747 5.27827 8.06576 5.271 9.57878C5.271 13.4379 9.66183 16.9671 11.0002 17.9479C12.3385 16.9671 16.7293 13.4379 16.7293 9.57878C16.7221 8.06576 16.1146 6.61747 15.0405 5.55189C13.9663 4.48632 12.5132 3.89057 11.0002 3.89544Z"
                                fill={"#FFFFFFB2"}
                            />
                            <path
                                d="M11.0003 11.6872C10.5018 11.6872 10.0144 11.5393 9.59983 11.2623C9.18528 10.9853 8.86218 10.5916 8.67138 10.131C8.48058 9.6704 8.43066 9.16355 8.52793 8.67455C8.6252 8.18556 8.86528 7.73639 9.21783 7.38384C9.57037 7.0313 10.0195 6.79121 10.5085 6.69395C10.9975 6.59668 11.5044 6.6466 11.965 6.8374C12.4256 7.02819 12.8193 7.35129 13.0963 7.76584C13.3733 8.18039 13.5212 8.66777 13.5212 9.16634C13.5212 9.83491 13.2556 10.4761 12.7828 10.9488C12.3101 11.4216 11.6689 11.6872 11.0003 11.6872ZM11.0003 8.02051C10.7737 8.02051 10.5522 8.08771 10.3637 8.21362C10.1753 8.33952 10.0284 8.51848 9.94172 8.72785C9.85499 8.93722 9.8323 9.16761 9.87651 9.38988C9.92072 9.61215 10.0299 9.81632 10.1901 9.97657C10.3503 10.1368 10.5545 10.2459 10.7768 10.2902C10.9991 10.3344 11.2294 10.3117 11.4388 10.225C11.6482 10.1382 11.8271 9.99136 11.9531 9.80293C12.079 9.6145 12.1462 9.39297 12.1462 9.16634C12.1462 8.86245 12.0254 8.571 11.8106 8.35612C11.5957 8.14123 11.3042 8.02051 11.0003 8.02051Z"
                                fill={"#FFFFFFB2"}
                            />
                        </svg>
                        <span>{city.city}</span>
                    </div>
                ) : null}

                {userRegionCity === "error" && !city.city ? (
                    <div className="geolocation__vpn-block">
                        <div className="geolocation-city" id="geolocation-city">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="info">
                                <path
                                    d="M6.94659 8.6663C6.33326 8.3063 5.91992 7.63964 5.91992 6.87297C5.91992 5.7263 6.84659 4.79297 7.99992 4.79297C8.76659 4.79297 9.43325 5.2063 9.79325 5.8263"
                                    stroke="#F68E42"
                                    strokeWidth="1.25"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path d="M3.99338 11.8728C2.76672 10.1994 1.87338 8.05942 2.42005 5.65942C3.52005 0.81942 9.71338 0.0394204 12.4534 3.31942" stroke="#F68E42" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M13.5866 5.66602C14.3533 9.05268 12.2466 11.9193 10.3999 13.6927C9.05993 14.986 6.93993 14.986 5.59326 13.6927" stroke="#F68E42" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M14.6668 1.33398L1.3335 14.6673" stroke="#F68E42" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <span className="geolocation-city__name">Доступ к геолокации запрещён в настройках. Разрешите доступ или укажите город вручную</span>
                        </div>
                        <div className="geolocation-button__group">
                            <ButtonUi label="Указать вручную" className="button__select" onClick={cityHandler} />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }),
);

export default AB_2771;
